import { SegmentedControl as MantineSegmentedControl, type SegmentedControlProps } from '@mantine/core';
import { vars } from '@ui-lib/css';
import { palettenext } from 'ui-lib/src/lib/color/palette-next';

import { Text } from '../Text/Text';

export const SegmentedControlText = (props: { active: boolean; children: string }) => (
  <Text weight="demibold" tone={props.active ? 'brandAccent' : 'secondary'}>
    {props.children}
  </Text>
);

export function SegmentedControl({ data, value, onChange }: Omit<SegmentedControlProps, 'styles'>) {
  return (
    <MantineSegmentedControl
      flex={1}
      c="brand.5"
      size="lg"
      radius="md"
      styles={{
        root: {
          height: '3rem',
          backgroundColor: palettenext.neutral[100],
          borderRadius: vars.border.radius.large,
        },
        label: {
          display: 'flex',
          height: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: vars.border.radius.large,
        },
      }}
      value={value}
      onChange={onChange}
      data={data}
    />
  );
}
